<!--
  ~ Copyright (c) Akveo 2019. All Rights Reserved.
  ~ Licensed under the Single Application / Multi Application License.
  ~ See LICENSE_SINGLE_APP / LICENSE_MULTI_APP in the 'docs' folder for license information on type of purchased license.
  -->

<div class="header-container">
  <div class="logo-container">
    <a (click)="toggleSidebar()" href="https://kc.etranscript.in/"
      class="sidebar-toggle">
      <nb-icon icon="menu-2-outline"></nb-icon>
    </a>
    <a class="logo" href="" (click)="navigateHome()"><img
        src=".\assets\images\sulogo.png" height="60" width="60" alt="logo">
      <font face="Garamond"><b> Etranscript</b></font><span></span>
    </a>
  </div> &nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;
</div>

<p (click)="demo()">FAQ &nbsp;&nbsp;&nbsp; <i class="fa fa-exclamation-triangle"></i></p>
<p (click)="open()">Contact us &nbsp;&nbsp;&nbsp; <i class="fa fa-envelope"></i></p>
<div class="header-container">
  <nb-action class="user-action">
    <nb-user [nbContextMenu]="userMenu" [onlyPicture]="userPictureOnly" [name]="usersData?.name"
      [picture]="user?.picture | ngxAuthToken | async">
    </nb-user>
  </nb-action>
</div>